import React from "react";
import styled from "styled-components";
import Particle from "../Particle";

const Contact = () => {
  const Wrapper = styled.section`
    padding: 7rem 0 5rem 0;

    .container {
        margin-top: 40px;
        border: 3px solid #623686;
        border-radius: 10px;
        box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 50px 60px;
        text-align: center;
        width: 750px;
        max-width: 100%;
    }

    .contact-form {
        max-width: 100rem;
        margin: auto;
    }


    body { background:rgb(30,30,40); }
    form { max-width:700px; margin:50px auto; }

    .feedback-input {

        color:white;
        font-family: Poppins;
        font-weight:500;
        font-size: 18px;
        border-radius: 5px;
        line-height: 22px;
        background-color: transparent;
        ${'' /* border:2px solid rgba(200, 137, 230, 0.637); */}
        border:2px solid #2C2C2C;
        transition: all 0.3s;
        padding: 13px;
        margin-bottom: 30px;
        width:100%;
        box-sizing: border-box;
        outline:0;
    }

    .feedback-input:focus { border:2px solid #6d20c5d7; }

    textarea {
        height: 150px;
        line-height: 150%;
        resize:vertical;
    }

    [type="submit"] {
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
        width: 100%;
        background:rgba(200, 137, 230, 0.637);
        border-radius:5px;
        border:0;
        cursor:pointer;
        color:white;
        font-size:24px;
        padding-top:10px;
        padding-bottom:10px;
        transition: all 0.3s;
        margin-top:-4px;
        font-weight:700;
    }
    [type="submit"]:hover { background:#6d20c5d7; }

  `;

  return (
    
    <Wrapper className="contact-section">
    <Particle />
    <div className="contact-section">
    
      {/* <h2> <strong className="purple">Feel Free to Contact ✨</strong></h2> */}
      <h2 style={{ marginBottom: '40px' }}>
            <strong className="purple">Feel Free to Contact ✨</strong>
        </h2>
      {/* <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15126.28620995241!2d73.92422475000001!3d18.59334505!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c14df5c70e0d%3A0x2d19689e09e2fced!2sPhoenix%20Mall%20Washrooms!5e0!3m2!1sen!2sin!4v1658905192255!5m2!1sen!2sin"
        width="100%"
        height="450"
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"></iframe> */}
        <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d236.53650837021996!2d73.87615133824669!3d18.457181749295675!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sin!4v1708949573309!5m2!1sen!2sin" width="90%" height="450" style={{border:0}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
      <div className="container">
        <div className="contact-form">
        <form
            action="https://formspree.io/f/mwkgboyd"
            method="POST"
        >      
            <input name="name" type="text" class="feedback-input" placeholder="Name" />   
            <input name="email" type="text" class="feedback-input" placeholder="Email" />
            <textarea name="text" class="feedback-input" placeholder="Message"></textarea>
            <input type="submit" value="Send"/>
        </form>
        </div>
      </div>
    </div>
    </Wrapper>
  );
};

export default Contact;



